import axios from 'axios';
import authHeader from './auth-header';
import config from '../Config';

const API_URL = config.API_URL;
const API_VERSION = config.API_VERSION;

const getSettingList = () => {
  return axios.get(API_URL + '/api/' + API_VERSION + '/settings/', {
    headers: authHeader(),
  });
};

const addCompanySetting = payload => {
  console.log(payload)
  return axios.patch(
    `${API_URL}/api/${API_VERSION}/company-settings/1/`,
    payload,
    { headers: authHeader() }
  );
};

const addNotificationSetting = payload => {
  return axios.patch(
    `${API_URL}/api/${API_VERSION}/notification-settings/1/`,
    payload,
    { headers: authHeader() }
  );
};

const addTaxComplianceSetting = payload => {
  return axios.patch(
    `${API_URL}/api/${API_VERSION}/tax-compliance-settings/1/`,
    payload,
    { headers: authHeader() }
  );
};

const addFinancialSetting = payload => {
  return axios.patch(
    `${API_URL}/api/${API_VERSION}/financial-settings/1/`,
    payload,
    { headers: authHeader() }
  );
};

const addTermsConditionSetting = payload => {
  return axios.patch(
    `${API_URL}/api/${API_VERSION}/terms-and-conditions/1/`,
    payload,
    { headers: authHeader() }
  );
};


const settingService = {
  getSettingList,
  addCompanySetting,
  addNotificationSetting,
  addTaxComplianceSetting,
  addFinancialSetting,
  addTermsConditionSetting
};
export default settingService;


